module.exports = __webpack_public_path__ + "static/media/easyjet.2923ea7f.png";